import { useForm } from '@tanstack/react-form'
import { FF } from 'ui/components'
import { CompanySelect } from 'ui/components/Select'
import { FilterPanel } from 'ui/components/Table'
import { FilterWrapper } from 'ui/temp/Filter'
import { TableFilterRow } from 'ui/temp/TableFilterRow'
import { useAlertsContext } from '~bank-alerts/context'
import { AlertsPayload } from '~bank-alerts/types'

import * as SC from './styles'

export const Filter = () => {
  const { data, search, onFilterChange } = useAlertsContext()
  const { relationshipOptions, form } = data

  const formApi = useForm({
    defaultValues: {
      highRiskReviewCompanyID: form.highRiskReviewCompanyID
    }
  })

  const clearForm = () => {
    formApi.reset()
    onFilterChange(
      {
        highRiskReviewCompanyID: undefined,
        highRiskReviewPage: 1
      },
      'highRiskReview'
    )
  }

  const updateSearchParams = (newValue: Partial<AlertsPayload>) => {
    onFilterChange({ ...search, ...newValue, highRiskReviewPage: 1 }, 'highRiskReview')
  }

  const hasActiveFilters = Boolean(search.highRiskReviewCompanyID)

  return (
    <FilterPanel isDirty={hasActiveFilters} onReset={clearForm} expanded={false}>
      <FilterWrapper>
        <TableFilterRow>
          <SC.ItemWrapper>
            <formApi.Field
              name="highRiskReviewCompanyID"
              listeners={{
                onChange: ({ value }) => {
                  updateSearchParams({ highRiskReviewCompanyID: value })
                }
              }}
              children={(field) => (
                <FF
                  field={field}
                  label="Relationships"
                  input={(inputProps) => (
                    <CompanySelect hideMyCompaniesFilter preloadedOptions={relationshipOptions} {...inputProps} />
                  )}
                />
              )}
            />
          </SC.ItemWrapper>
        </TableFilterRow>
      </FilterWrapper>
    </FilterPanel>
  )
}
